import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getModuleData } from '../../../../selectors/modules';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { Props } from './ExhibitionistEmptyState';

type StateProps = Pick<Props, 'isOwner' | 'username' | 'sourceType'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => ({
  isOwner: isCurrentUserProfileOwner(state),
  username: getProfileOwnerUser(state).username,
  sourceType: getModuleData(state, ownProps.moduleId).sourceType,
});

export default connect(mapStateToProps);
